import React from 'react';
import { Icon } from './Icon.js';
export const IconMsgFilled = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m10,2C5.589,2,2,5.589,2,10c0,1.44.388,2.789,1.057,3.958l-1.018,3.055c-.09.27-.02.567.181.768.143.143.334.22.53.22.08,0,.16-.013.237-.039l3.055-1.018c1.169.669,2.518,1.057,3.958,1.057,4.411,0,8-3.589,8-8S14.411,2,10,2Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconMsgFilled.js.map